export default __webpack_public_path__ + "static/media/netherlands.5f335a38.svg";